export const GET_ACCOMMODATIONS = 'dashboard/package/GET_ACCOMMODATIONS';
export const GET_ACCOMMODATIONS_SUCCESS =
  'dashboard/package/GET_ACCOMMODATIONS_SUCCESS';

export const GET_ACCOMMODATIONS_AVAILABILITY =
  'dashboard/package/GET_ACCOMMODATIONS_AVAILABILITY';
export const GET_ACCOMMODATIONS_AVAILABILITY_SUCCESS =
  'dashboard/package/GET_ACCOMMODATIONS_AVAILABILITY_SUCCESS';

export const GET_EXTRAS = 'dashboard/package/GET_EXTRAS';
export const GET_EXTRAS_SUCCESS = 'dashboard/package/GET_EXTRAS_SUCCESS';

export const GET_ACCOMMODATION_EXTRAS =
  'dashboard/package/GET_ACCOMMODATION_EXTRAS';
export const GET_ACCOMMODATION_EXTRAS_SUCCESS =
  'dashboard/package/GET_ACCOMMODATION_EXTRAS_SUCCESS';

export const GET_TRANSPORT_TYPES = 'dashboard/package/GET_TRANSPORT_TYPES';
export const GET_TRANSPORT_TYPES_SUCCESS =
  'dashboard/package/GET_TRANSPORT_TYPES_SUCCESS';

export const CLEAR_TRANSPORT_LOCATIONS =
  'dashboard/package/CLEAR_TRANSPORT_LOCATIONS';
export const GET_TRANSPORT_LOCATIONS =
  'dashboard/package/GET_TRANSPORT_LOCATIONS';
export const GET_TRANSPORT_LOCATIONS_SUCCESS =
  'dashboard/package/GET_TRANSPORT_LOCATIONS_SUCCESS';

export const CLEAR_TRANSPORT_STOPS = 'dashboard/package/CLEAR_TRANSPORT_STOPS';
export const GET_TRANSPORT_STOPS = 'dashboard/package/GET_TRANSPORT_STOPS';
export const GET_TRANSPORT_STOPS_SUCCESS =
  'dashboard/package/GET_TRANSPORT_STOPS_SUCCESS';
export const GET_TRANSPORT_OUTBOUND_STOPS =
  'dashboard/package/GET_TRANSPORT_OUTBOUND_STOPS';
export const GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS =
  'dashboard/package/GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS';
export const GET_TRANSPORT_RETURN_STOPS =
  'dashboard/package/GET_TRANSPORT_RETURN_STOPS';
export const GET_TRANSPORT_RETURN_STOPS_SUCCESS =
  'dashboard/package/GET_TRANSPORT_RETURN_STOPS_SUCCESS';

export const CLEAR_TRANSPORT_DATES = 'dashboard/package/CLEAR_TRANSPORT_DATES';
export const GET_TRANSPORT_DATES = 'dashboard/package/GET_TRANSPORT_DATES';
export const GET_TRANSPORT_DATES_SUCCESS =
  'dashboard/package/GET_TRANSPORT_DATES_SUCCESS';

export const GET_TRANSPORT_ROUTES = 'dashboard/package/GET_TRANSPORT_ROUTES';
export const GET_TRANSPORT_ROUTES_SUCCESS =
  'dashboard/package/GET_TRANSPORT_ROUTES_SUCCESS';

export const GET_EXTRAS_AVAILABILITY =
  'dashboard/package/GET_EXTRAS_AVAILABILITY';
export const GET_EXTRAS_AVAILABILITY_SUCCESS =
  'dashboard/package/GET_EXTRAS_AVAILABILITY_SUCCESS';

export const GET_EXTRA_AVAILABILITY =
  'dashboard/package/GET_EXTRA_AVAILABILITY';
export const GET_EXTRA_AVAILABILITY_SUCCESS =
  'dashboard/package/GET_EXTRA_AVAILABILITY_SUCCESS';

export const GET_TICKETS = 'dashboard/package/GET_TICKETS';
export const GET_TICKETS_SUCCESS = 'dashboard/package/GET_TICKETS_SUCCESS';

export const GET_TICKETS_AVAILABILITY =
  'dashboard/package/GET_TICKETS_AVAILABILITY';
export const GET_TICKETS_AVAILABILITY_SUCCESS =
  'dashboard/package/GET_TICKETS_AVAILABILITY_SUCCESS';

export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS';
export const GET_TERMS_CONDITIONS_SUCCESS = 'GET_TERMS_CONDITIONS_SUCCESS';
export const GET_TERMS_CONDITIONS_FAILED = 'GET_TERMS_CONDITIONS_FAILED';
